<template>
  <div>
    <van-nav-bar
      style="background: #ffffff; color: #323233; font-weight: bold"
      fixed
      title="退货单详情"
      left-arrow
      @click-left="onClickLeft"
    />
    <div id="aaa"></div>

    <van-cell-group title="影像中心" :border="false" style="margin-left: 10px">
      <van-cell
        icon="location-o"
        :title="currentAgent.name"
        style="border-bottom: 0.1px solid #f5f5f5"
      />
    </van-cell-group>
    <van-cell-group title="采购订单" :border="false" style="margin-left: 10px">
      <van-cell
        icon="orders-o"
        :title="purchaseOrderNum"
        style="border-bottom: 0.1px solid #f5f5f5"
      />
    </van-cell-group>

    <van-cell-group title="备注" :border="false" style="margin-left: 10px">
      <van-cell icon="edit" style="border-bottom: 0.1px solid #f5f5f5">
        <van-field
          v-model="message"
          :disabled="!isFirstNode || !permission"
          rows="2"
          autosize
          type="textarea"
          maxlength="50"
          placeholder="请输入备注信息"
          show-word-limit
        />
      </van-cell>
    </van-cell-group>

    <van-cell-group title="退货明细" :border="false">
      <van-cell class="haha">
        <van-cell v-if="returnDetail[0]">
          <van-swipe-cell
            v-for="(item, index) in returnDetail"
            :key="index"
            style="border-bottom: 0.2px solid #dcdcdc"
          >
            <van-row class="ha" type="flex">
              <van-col span="24">{{ item.model_name }}</van-col>
            </van-row>
            <van-row type="flex" justify="space-between">
              <van-col span="8">
                <span style="color: #969799">采购数量:</span>
                <span style="color: #323233; font-weight: bold">{{
                  item.old_quantity
                }}</span>
              </van-col>
            </van-row>
            <van-row type="flex">
              <van-col span="24">
                <span style="color: #969799">退货数量:</span>
                <input
                  type="text"
                  :disabled="!isFirstNode || !permission"
                  v-model="item.quantity"
                  style="
                    width: 75%;
                    height: 50%;
                    color: #323233;
                    font-weight: bold;
                  "
                />
              </van-col>
            </van-row>
            <van-button
              style="height: 100%"
              slot="right"
              square
              text="删除"
              type="danger"
              class="delete-button"
              @click="del(index)"
            />
          </van-swipe-cell>
        </van-cell>
      </van-cell>
      <van-cell>
        <van-icon
          v-if="orderDetail[0] && isFirstNode"
          name="add-o"
          color="#07c160"
          size="40"
          @click="add"
          style="float: right"
        />
      </van-cell>
    </van-cell-group>

    <van-cell-group v-if="permission">
      <van-cell>
        <van-row type="flex">
          <van-col span="10">
            <van-button round type="info" @click="tijiao">提交</van-button>
          </van-col>
          <van-col span="2"></van-col>
          <van-col span="10">
            <van-button round type="info" @click="tuihui">退回</van-button>
          </van-col>
        </van-row>
      </van-cell>
    </van-cell-group>
    <div
      v-show="bottom_tip"
      style="font-size: 10px; text-align: center; padding: 10px 10px"
    >
      ©2020 一脉阳光集团信息中心
    </div>
    <van-dialog
      v-model="show"
      title="请仔细核查"
      show-cancel-button
      @confirm="qrtj"
    >
      <van-cell-group title="影像中心" :border="false">
        <van-cell :title="currentAgent.name" />
      </van-cell-group>
      <van-cell-group title="退货明细" :border="false">
        <van-cell v-for="(item, index) in returnDetail" :key="index">
          <van-row type="flex">
            <van-col span="6">耗材型号：</van-col>
            <van-col span="18">{{ item.model_name }}</van-col>
          </van-row>
          <van-row type="flex">
            <van-col span="6">采购数量：</van-col>
            <van-col span="18">{{ item.old_quantity }}</van-col>
          </van-row>
          <van-row type="flex">
            <van-col span="6">退货数量：</van-col>
            <van-col span="18">{{ item.quantity }}</van-col>
          </van-row>
        </van-cell>
      </van-cell-group>
    </van-dialog>
  </div>
</template>
<script>
import {
  SwipeCell,
  Icon,
  NavBar,
  Tag,
  DropdownMenu,
  DropdownItem,
  Col,
  Row,
  Button,
  Dialog,
  Toast,
} from "vant";
import { mapState, mapMutations } from "vuex";

export default {
  components: {
    [NavBar.name]: NavBar,
    [Tag.name]: Tag,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [SwipeCell.name]: SwipeCell,
    [Toast.name]: Toast,
    [Button.name]: Button,
    [Dialog.Component.name]: Dialog.Component,
    [Row.name]: Row,
  },
  data() {
    return {
      show: false,
      //备注信息
      message: "",
      bottom_tip: true,
      //obj 选中的影像中心的所有采购订单
      purchaseOrderInfo: "",
      //选中的订单的明细
      orderDetail: [],
      //退货的明细
      returnDetail: [],
      //当前选中的订单
      purchaseOrderNum: "",
      //当前选中的影像中心
      currentAgent: "",
      //公司编码
      companyErpCode: "",
      //供应商编码
      vendorCode: "",
      permission: "",
      isFirstNode: "",
      mainid: "",
      currentnode: "",
      project_erp_code: "",
    };
  },

  methods: {
    ...mapMutations(["changePermissionAgent", "changeDefaultAgentIndex"]),
    onClickLeft() {
      this.$router.push({
        name: "salesreturn",
        query: {
          ms: this.$route.query.ms,
          node: this.$route.query.node,
          isall: this.$route.query.isall,
        },
      });
    },
    add() {
      //window.console.log(this.orderDetail);
      this.$router.push({
        name: "returnorderdetail",
        params: {
          orderDetail: this.orderDetail,
          orderNum: this.purchaseOrderNum,
          confirmDetail: this.returnDetail,
          message: this.message,
          refer: "salesreturndetail",
          mainid: this.mainid,
        },
      });
    },
    del(index) {
      //window.console.log(index);
      this.returnDetail.splice(index, 1);
    },
    tijiao() {
      this.show = true;
    },
    tuihui() {
      let that = this;
      let data = {
        mainid: this.mainid,
        creater: localStorage.getItem("usermobile"),
        remark: this.message ? this.message : "",
        currentnode: this.currentnode,
        projectErpCode: this.project_erp_code,
      };
      this.$http({
        method: "post",
        url: "/mobile/returngoods/returnNode",
        data,
      }).then(function (response) {
        if (response.state == 200) {
          Toast.success("退回成功");
          //window.console.log(response);
          that.$router.push("salesreturn");
        }
      });
    },
    qrtj() {
      let that = this;
      if (!this.returnDetail[0]) {
        Toast("明细不能为空");
        return;
      }

      let result = this.parseSubmitData(this.returnDetail);
      //window.console.log(result);
      if (result.message) {
        Toast(result.message);
        return;
      } else {
        if (result.data[0]) {
          let data = {
            mainid: this.mainid,
            creater: localStorage.getItem("usermobile"),
            remark: this.message ? this.message : "",
            currentnode: this.currentnode,
            project_erp_code: this.project_erp_code,
            detail: result.data,
          };
          //window.console.log(data);
          Toast.loading({
            message: "加载中...",
            forbidClick: true,
          });

          this.$http({
            method: "post",
            url: "/mobile/returngoods/submitNode",
            data,
          }).then(function (response) {
            if (response.state == 200) {
              Toast.success("提交成功");
              //window.console.log(response);
              that.$router.push("salesreturn");
            }
          });
        } else {
          Toast("入库数量不能全部为空");
          return;
        }
      }
    },
    parseSubmitData(obj) {
      let newarr = [];
      let message = "";
      for (let i = 0; i < obj.length; i++) {
        if (!obj[i].quantity || obj[i].quantity == 0) {
          continue;
        }
        if (obj[i].quantity && obj[i].quantity > obj[i].old_quantity) {
          let num = i + 1;
          message =
            message + "第" + num + "条明细,退货数量不能超过采购数量！\n";
        }

        let newobj = {
          return_detail_id: obj[i].id || obj[i].return_detail_id,
          order_detail_id:
            obj[i].purchase_order_detail_id || obj[i].order_detail_id,
          brand_uuid: obj[i].brand_uuid,
          model_uuid: obj[i].model_uuid,
          unit: obj[i].unit,
          quantity: obj[i].quantity || "0",
          tax_unit_price: obj[i].tax_unit_price,
          warehouse_id: obj[i].warehouse_id,
          old_quantity: obj[i].old_quantity,
        };
        newarr.push(newobj);
      }
      return {
        message: message,
        data: newarr,
      };
    },
    handleAjax(instance, id) {
      instance.$http
        .post("/mobile/returngoods/detailList", {
          mainid: id,
          mobile: localStorage.getItem("usermobile"),
        })
        .then(function (response) {
          // window.console.log(response.record);
          instance.purchaseOrderNum = response.record.main.purchase_order_num;
          instance.message = response.record.main.remark;
          instance.inventoryNum = response.record.main.inventory_num;
          instance.currentnode = response.record.main.currentnode;
          instance.project_erp_code = response.record.main.project_erp_code;
          instance.returnDetail =
            instance.$route.params.confirmDetail || response.record.detail;
          instance.permission = response.permission;
          instance.isFirstNode = response.is_first_node;
          //window.console.log(instance.permission);
          instance.$http
            .post("/mobile/returngoods/getOrderDetailByNum", {
              projectErpCode: instance.currentAgent.erp_code,
              purchaseOrderNum: instance.purchaseOrderNum,
            })
            .then(function (response) {
              if (response.data.detail) {
                instance.orderDetail = response.data.detail;
              }
            });
        });
    },
  },
  computed: {
    ...mapState(["permissionAgent", "defaultAgentIndex"]),
  },

  created() {
    if (this.permissionAgent) {
      let _this = this;
      this.currentAgent = this.permissionAgent.find(function (item) {
        return item.id == _this.defaultAgentIndex;
      });
      this.mainid = this.$route.query.id || this.$route.params.mainid;
      this.handleAjax(this, this.mainid);
    } else {
      let _this = this;
      this.$http
        .post("/mobile/rimsAgentList", {
          username: localStorage.getItem("usermobile"),
        })
        .then(function (response) {
          if (response) {
            _this.changePermissionAgent(response.rimsAgent);
            _this.changeDefaultAgentIndex(response.rimsAgent[0].id);
            _this.currentAgent = _this.permissionAgent.find(function (item) {
              return item.id == _this.defaultAgentIndex;
            });
            _this.mainid = _this.$route.query.id || _this.$route.params.mainid;
            _this.handleAjax(this, this.$route.query.id);
          }
        });
    }
  },
};
</script>
<style scoped lang="less">
.van-nav-bar__title {
  font-weight: 800;
  color: white;
}
.van-nav-bar .van-icon {
  color: white;
}
.van-nav-bar .van-icon {
  color: white;
}

.haha .van-cell {
  line-height: 1.2rem !important;
  border: 1px solid #dadae4;
  margin-bottom: 10px;
}
.ha {
  font-weight: bold;
}

.van-tag {
  margin-left: 2%;
}

.van-button {
  width: 100%;
}
#aaa {
  width: 100vw;
  height: 46px;
}
.van-nav-bar__title {
  font-weight: 800;
  color: #323233;
}
.van-nav-bar .van-icon {
  color: rgba(0, 0, 0, 0.7);
}
.van-tag--default {
  background-color: #f7f8fa;
}
.choiceWarhouse .van-tag {
  padding: 0.6em 1.5em !important;
  /*font-weight: bold;*/
  font-size: 0.4rem;
  margin: 0.2em;
  color: #323233;
  border-radius: 10px;
}
.van-cell-group__title {
  color: #323233 !important;
  font-weight: bold;
  font-size: 0.38rem;
  background-color: #f7f8fa;
}
.van-cell {
  color: #969799 !important;
}
.van-tag--danger.van-tag--plain {
  color: rgb(131, 134, 131);
}
.upload-img {
  display: flex;
  flex-wrap: wrap;
}
.img-box {
  width: 88px;
  height: 88px;
  margin-right: 8px;
  margin-bottom: 8px;
}
.image {
  width: 88px;
  height: 88px;
}
</style>